module.exports = __webpack_public_path__ + "static/img/silhouette_04.2595b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/silhouettes/thumbnail/silhouette_04.png
// module id = uB24
// module chunks = 0